module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/vocabulary/components/delete-concept-version.component.scss
// module id = ./src/app/vocabulary/components/delete-concept-version.component.scss
// module chunks = main